import React from 'react';

const STRATEGY_BADGE = {
  conservative: { label: '안정형', background: '#ea580c' },
  stable:       { label: '균형형', background: '#2563eb' },
  expand:       { label: '확장형', background: '#16a34a' },
};

/**
 * DG Engine 수락 확률 뱃지
 * ARES 후보 카드에 표시되는 개인 맞춤 예측 정보
 */
function DGPredictionBadge({ predictions, score, strategy }) {
  if (!predictions && score === undefined && !strategy) return null;

  const acceptProb = predictions?.accept_prob;
  const rejectRisk = predictions?.reject_risk;
  const noShowRisk = predictions?.no_show_risk;

  if (acceptProb === undefined && score === undefined && !strategy) return null;

  const pct    = acceptProb !== undefined ? Math.round(acceptProb * 100) : null;
  const risk   = rejectRisk !== undefined ? Math.round(rejectRisk * 100) : null;
  const noShow = noShowRisk !== undefined ? Math.round(noShowRisk * 100) : null;

  // 색상: 70% 이상 초록, 40~70% 주황, 40% 미만 빨강
  const color =
    pct === null ? '#7c3aed' :
    pct >= 70 ? '#16a34a' :
    pct >= 40 ? '#d97706' :
    '#dc2626';

  const badgeStyle = {
    fontSize: 11,
    fontWeight: 600,
    color: '#fff',
    borderRadius: 8,
    padding: '2px 7px',
  };

  const strategyInfo = strategy ? STRATEGY_BADGE[strategy] : null;

  return (
    <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap', marginTop: 4 }}>
      {strategyInfo && (
        <span style={{ ...badgeStyle, background: strategyInfo.background }}>
          {strategyInfo.label}
        </span>
      )}
      {pct !== null && (
        <span style={{ ...badgeStyle, background: color }}>
          수락 {pct}%
        </span>
      )}
      {risk !== null && risk > 20 && (
        <span style={{ ...badgeStyle, background: '#dc2626' }}>
          거절위험 {risk}%
        </span>
      )}
      {noShow !== null && noShow > 5 && (
        <span style={{ ...badgeStyle, background: '#8b5cf6' }}>
          노쇼위험 {noShow}%
        </span>
      )}
      {score !== undefined && (
        <span
          style={{
            fontSize: 10,
            color: '#7c3aed',
            border: '1px solid #7c3aed',
            borderRadius: 8,
            padding: '1px 6px',
          }}
        >
          DG {Math.round(score * 100)}점
        </span>
      )}
    </div>
  );
}

export default DGPredictionBadge;
